import styled from 'styled-components';

export const StyledFormActions = styled.div`
  padding: 15px 0;

  small {
    text-align: center;
    display: block;
    margin: 5px 0 0;
  }

  .submit-wrapper {
    justify-content: flex-end;
  }

  &.sticky {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    background: #fcfcfc;
    border-top: 1px ${props => props.theme.colors.border} solid;
    box-shadow: 0 -3px 7px rgba(0,0,0, 0.1);
    z-index: 999;

    #form-action-container {
      max-width: ${props => props.theme.containerWidth};
      margin: 0 auto;
      padding: 0 15px;
    }
  }
`

export const StyledFormActionsWrapper = styled.div`
  height: 90px;
  margin-top: 20px;
  margin-bottom: -15px;
`

export const StyleBack = styled.div`
  margin-top: 15px;
  text-align: center;

  .or {
    font-size: ${props => props.theme.fontSizes.small};
    opacity: 0.5;
  }

  a {
    margin-top: 15px;
    text-transform: lowercase;
    display: block;
  }
`
